import { __decorate, __extends } from "tslib";
import { Component, Vue } from 'vue-property-decorator';

var SurveyMixins = function (_super) {
  __extends(SurveyMixins, _super);

  function SurveyMixins() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.loading = false;
    _this.submitLoading = false;
    _this.isSuccessLoad = false;
    _this.isFinished = false;
    return _this;
  }

  SurveyMixins.prototype.initDetails = function () {
    return {
      id: undefined,
      title: '',
      welcome_text: '',
      question_list: [],
      dependent_list: [],
      type_id: undefined
    };
  };

  SurveyMixins = __decorate([Component], SurveyMixins);
  return SurveyMixins;
}(Vue);

export default SurveyMixins;